// extracted by mini-css-extract-plugin
export default {"custom001":"GovernancePage_custom001__etA8G"};